<template>
    <article class="media-card">
        <div v-if="imageUrl"
             :style="{ 'background-image': `url(${imageUrl})`}"
             class="media-card__image"
        ></div>
        <div class="media-card__title" v-html="name"></div>
        <p class="media-card__description" v-html="description"></p>

        <rounded-button v-if="!isFileUrlEmpty"
                        :url="fileUrl"
                        class="media-card__download-link"
                        title="Télécharger"
        />
    </article>
</template>

<script>
    import RoundedButton from '@/components/RoundedButton';

    export default {
        name: 'MediaCard',

        components: { RoundedButton },

        props: {
            name:        { type: String, required: true },
            description: { type: String, required: true },
            imageUrl:    { type: String, required: true },
            imageAlt:    { type: String, required: true },
            fileUrl:     { type: String, required: true },
        },

        computed: {
            isFileUrlEmpty () {
                return this.fileUrl.trim() === '';
            },
        },
    };
</script>

<style scoped lang="scss">
    @import '../../assets/styles/abstracts/variables';

    .media-card {
        display:        flex;
        flex-direction: column;

        // Fix for IE 11
        flex:           0 0 auto;
        width:          100%;

        margin-bottom:  2rem;
        padding:        1.5rem 1.5rem 2rem;

        border:         0.1rem solid $gray-300;
        background:     $white;

        @media screen and (min-width: map_get($grid-breakpoints, 'sm')) {
            margin-bottom: 3rem;
            padding:       3rem;
        }

        &__image {
            margin-bottom:       1.5rem;
            padding-top:         (190px * 100% / 298px);

            background-size:     cover;
            background-position: center;
        }

        &__title {
            font-weight: 600;
            font-size:   1.2rem;
            line-height: (20 / 12);

            @media screen and (min-width: map_get($grid-breakpoints, 'sm')) {
                font-size:   1.6rem;
                line-height: (20 / 16);
            }
        }

        &__description {
            line-height: (20 / 12);
            font-size:   1.2rem;
        }

        &__download-link {
            align-self: center;

            margin-top: auto;
        }
    }
</style>
